export const OwnCollectFrequency = Object.freeze();

const OwnCollectFrequencyTypeEnum = {
    FIXED: "fixed",
    DYNAMIC: "dynamic",
}

export default Object.freeze({
    ...OwnCollectFrequencyTypeEnum,
});

export const OwnCollectFrequencyTitleEnum = Object.freeze({
    [OwnCollectFrequencyTypeEnum.FIXED]: "Fixa",
    [OwnCollectFrequencyTypeEnum.DYNAMIC]: "Dinâmica",
});

